
<template>
  <div class="c-menu">
    <div
      class="c-menu__btn"
      v-on:click="toggleMenu()"
      v-bind:class="{'c-menu__btn--open':menuOpen}"
    >
      <span class="c-menu__btn-bar"></span>
      <span class="c-menu__btn-bar"></span>
      <span class="c-menu__btn-bar"></span>
      <span class="c-menu__btn-bar"></span>

      <div class="c-menu__btn-text">
        <p class="c-menu__btn-inner">MENU</p>
        <p v-if="menuOpen" class="c-menu__btn-inner c-menu__btn-inner--open">CLOSE</p>
        <p v-if="!menuOpen" class="c-menu__btn-inner c-menu__btn-inner--open">OPEN</p>
      </div>
    </div>

    <div
      class="c-menu__offcanvas"
      id="offcanvas-perspective"
      v-bind:class="{'c-menu__offcanvas--open':menuCanOpen}"
    >
      <span id="perspective-circle" class="c-menu__circle"></span>
      <span id="menu-mask" class="c-menu__mask"></span>
      <div class="c-menu__items js-panel">
        <ul class="c-menu__link-list">
          <li
            class="c-menu__link-listItem"
            v-bind:class="{'c-menu__link-listItem--active': activeRoute == 'home'}"
          >
            <a @mouseover="animateMenuItem('H', false, 'I')" class="c-menu__menu-item" href>
              <span class="c-menu__counter"></span>
              <router-link to="/" class="c-menu__menu-itemInner">HOME</router-link>
            </a>
          </li>
          <li
            class="c-menu__link-listItem"
            v-bind:class="{'c-menu__link-listItem--active': activeRoute == 'shop'}"
          >
            <a @mouseover="animateMenuItem('S', false, 'II')" class="c-menu__menu-item" href>
              <span class="c-menu__counter"></span>
              <router-link to="/shop" class="c-menu__menu-itemInner">SHOP</router-link>
            </a>
          </li>
          <li
            class="c-menu__link-listItem"
            v-bind:class="{'c-menu__link-listItem--active': activeRoute == 'about'}"
          >
            <a @mouseover="animateMenuItem('A', false, 'III')" class="c-menu__menu-item" href>
              <span class="c-menu__counter"></span>
              <router-link to="/about" class="c-menu__menu-itemInner">ABOUT</router-link>
            </a>
          </li>
          <div class="c-menu__sub-items">
            <li
              class="c-menu__link-listItem c-menu__link-listItem--minor"
              v-bind:class="{'c-menu__link-listItem--active': activeRoute == 'contact'}"
            >
              <a @mouseover="animateMenuItem('C', false, 'IV')" class="c-menu__menu-item" href>
                <span class="c-menu__counter"></span>
                <router-link to="/contact" class="c-menu__menu-itemInner">CONTACT</router-link>
              </a>
            </li>
            <li
              class="c-menu__link-listItem c-menu__link-listItem--minor"
              v-bind:class="{'c-menu__link-listItem--active': activeRoute == 'terms and conditions'}"
            >
              <a @mouseover="animateMenuItem('T', false, 'V')" class="c-menu__menu-item" href>
                <span class="c-menu__counter"></span>
                <router-link to="/termsandconditions" class="c-menu__menu-itemInner">T&C's</router-link>
              </a>
            </li>
            <li
              class="c-menu__link-listItem c-menu__link-listItem--minor"
              v-bind:class="{'c-menu__link-listItem--active': activeRoute == 'shipping and returns'}"
            >
              <a @mouseover="animateMenuItem('S', false, 'VII')" class="c-menu__menu-item" href>
                <span class="c-menu__counter"></span>
                <router-link to="/shippingandreturns" class="c-menu__menu-itemInner">SHIPPING</router-link>
              </a>
            </li>
            <li
              class="c-menu__link-listItem c-menu__link-listItem--minor"
              v-bind:class="{'c-menu__link-listItem--active': activeRoute == 'shipping and returns'}"
            >
              <a @mouseover="animateMenuItem('R', false, 'VI')" class="c-menu__menu-item" href>
                <span class="c-menu__counter"></span>
                <router-link to="/shippingandreturns" class="c-menu__menu-itemInner">RETURNS</router-link>
              </a>
            </li>
            <li
              class="c-menu__link-listItem c-menu__link-listItem--minor"
              v-bind:class="{'c-menu__link-listItem--active': activeRoute == 'privacy policy'}"
            >
              <a @mouseover="animateMenuItem('P', false, 'VIII')" class="c-menu__menu-item" href>
                <span class="c-menu__counter"></span>
                <router-link to="/privacypolicy" class="c-menu__menu-itemInner">PRIVACY POLICY</router-link>
              </a>
            </li>
          </div>
        </ul>
      </div>
      <div class="c-menu__images js-panel">
        <ul class="c-menu__image-list">
          <li class="c-menu__image-item">
            <router-link to="/product/ring-thomas">
              <div
                class="js-hover-effect"
                @mouseover="animateMenuItem('T', true, 'Thomas')"
                style="height:100%;"
                data-displacement="../assets/img/displacement/4.png"
                data-intensity="-0.65"
                data-speed-in="1.2"
                data-speed-out="1.2"
              >
                <img
                  loading="lazy"
                  class="js-menu-img"
                  style="display:none;"
                  src="/assets/img/Celtic-2.webp"
                  alt="Signet ring - Thomas"
                />
                <img
                  loading="lazy"
                  class="js-menu-img"
                  style="display:none;"
                  src="/assets/img/Celtic-grey-2.webp"
                  alt="Signet ring - Thomas"
                />
              </div>
            </router-link>
          </li>
          <li class="c-menu__image-item">
            <router-link to="/product/ring-trixy">
              <div
                class="js-hover-effect"
                @mouseover="animateMenuItem('T', true, 'Trixy')"
                style="height:100%;"
                data-displacement="../assets/img/displacement/5.png"
                data-intensity="-0.65"
                data-speed-in="1.2"
                data-speed-out="1.6"
              >
                <img
                  loading="lazy"
                  class="js-menu-img"
                  style="display:none;"
                  src="/assets/img/Celtic-2.webp"
                  alt="Signet ring - Trixy"
                />
                <img
                  loading="lazy"
                  class="js-menu-img"
                  style="display:none;"
                  src="/assets/img/Celtic-grey-2.webp"
                  alt="Signet ring - Trixy"
                />
              </div>
            </router-link>
          </li>
          <li class="c-menu__image-item">
            <router-link to="/product/ring-lupus">
              <div
                class="js-hover-effect"
                @mouseover="animateMenuItem('L', true, 'Lupus')"
                style="height:100%;"
                data-displacement="../assets/img/displacement/4.png"
                data-intensity="-0.65"
                data-speed-in="1.2"
                data-speed-out="1.2"
              >
                <img
                  loading="lazy"
                  class="js-menu-img"
                  style="display:none;"
                  src="/assets/img/Celtic-2.webp"
                  alt="Signet ring - Lupus"
                />
                <img
                  loading="lazy"
                  class="js-menu-img"
                  style="display:none;"
                  src="/assets/img/Celtic-grey-2.webp"
                  alt="Signet ring - Lupus"
                />
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="c-menu__decoration js-panel">
        <span class="c-menu__letter" id="letter">{{currentLetter}}</span>
        <div class="c-menu__pagination">
          <span class="c-menu__pagenumber">
            <h1 class="c-menu__page c-menu__page--current">{{ symbol }}</h1>
            <span class="c-menu__divider">/</span>
            <h1 class="c-menu__page c-menu__page--hover">IV</h1>
          </span>
          <span class="c-menu__ringname">
            <h1 class="c-menu__ringname-text">{{ symbol }}</h1>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from "./vendor/three.js";
var imagesLoaded = require("imagesloaded");

const imgUrls = [
  ["/assets/img/Celtic-grey-2.webp", "/assets/img/Celtic-2.webp"],
  ["/assets/img/Ornate-grey-2.webp", "/assets/img/Ornate-2.webp"],
  ["/assets/img/Egypt-grey-2.webp", "/assets/img/Egypt-2.webp"],
];
const imgUrlsPng = [
  ["/assets/img/Celtic-grey-2.png", "/assets/img/Celtic-2.png"],
  ["/assets/img/Ornate-grey-2.png", "/assets/img/Ornate-2.png"],
  ["/assets/img/Egypt-grey-2.png", "/assets/img/Egypt-2.png"],
];

var hoverEffect = function (opts) {
  var vertex = `
        varying vec2 vUv;
        void main() {
          vUv = uv;
          gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
    `;

  var fragment = `
        varying vec2 vUv;

        uniform sampler2D texture;
        uniform sampler2D texture2;
        uniform sampler2D disp;

        // uniform float time;
        // uniform float _rot;
        uniform float dispFactor;
        uniform float effectFactor;

        // vec2 rotate(vec2 v, float a) {
        //  float s = sin(a);
        //  float c = cos(a);
        //  mat2 m = mat2(c, -s, s, c);
        //  return m * v;
        // }

        void main() {

            vec2 uv = vUv;

            // uv -= 0.5;
            // vec2 rotUV = rotate(uv, _rot);
            // uv += 0.5;

            vec4 disp = texture2D(disp, uv);

            vec2 distortedPosition = vec2(uv.x + dispFactor * (disp.r*effectFactor), uv.y);
            vec2 distortedPosition2 = vec2(uv.x - (1.0 - dispFactor) * (disp.r*effectFactor), uv.y);

            vec4 _texture = texture2D(texture, distortedPosition);
            vec4 _texture2 = texture2D(texture2, distortedPosition2);

            vec4 finalTexture = mix(_texture, _texture2, dispFactor);

            gl_FragColor = finalTexture;
            // gl_FragColor = disp;
        }
    `;

  var parent = opts.parent || console.warn("no parent");
  var dispImage =
    opts.displacementImage || console.warn("displacement image missing");
  var image1 = opts.image1 || console.warn("first image missing");
  var image2 = opts.image2 || console.warn("second image missing");
  var intensity = opts.intensity || 1;
  var speedIn = opts.speedIn || 1.6;
  var speedOut = opts.speedOut || 1.2;
  var userHover = opts.hover === undefined ? true : opts.hover;
  var easing = opts.easing || Expo.easeOut;

  var mobileAndTabletcheck = function () {
    var check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  };

  var scene = new THREE.Scene();
  var camera = new THREE.OrthographicCamera(
    parent.offsetWidth / -2,
    parent.offsetWidth / 2,
    parent.offsetHeight / 2,
    parent.offsetHeight / -2,
    1,
    1000
  );

  camera.position.z = 1;

  var renderer = new THREE.WebGLRenderer({
    antialias: false,
    // alpha: true
  });

  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setClearColor(0xffffff, 0.0);
  renderer.setSize(parent.offsetWidth + 10, parent.offsetHeight + 10);
  parent.appendChild(renderer.domElement);

  // var addToGPU = function(t) {
  //     renderer.setTexture2D(t, 0);
  // };

  var loader = new THREE.TextureLoader();
  loader.crossOrigin = "";
  var texture1 = loader.load(image1);
  var texture2 = loader.load(image2);

  var disp = loader.load(dispImage);
  disp.wrapS = disp.wrapT = THREE.RepeatWrapping;

  texture1.magFilter = texture2.magFilter = THREE.LinearFilter;
  texture1.minFilter = texture2.minFilter = THREE.LinearFilter;

  texture1.anisotropy = renderer.capabilities.getMaxAnisotropy();
  texture2.anisotropy = renderer.capabilities.getMaxAnisotropy();

  var mat = new THREE.ShaderMaterial({
    uniforms: {
      effectFactor: { type: "f", value: intensity },
      dispFactor: { type: "f", value: 0.0 },
      texture: { type: "t", value: texture1 },
      texture2: { type: "t", value: texture2 },
      disp: { type: "t", value: disp },
    },

    vertexShader: vertex,
    fragmentShader: fragment,
    transparent: true,
    opacity: 1.0,
  });

  var minWidth = parent.offsetWidth + 10;
  var geometry = new THREE.PlaneBufferGeometry(
    minWidth * 1.2,
    minWidth * 0.6 * 1.2,
    1
  );
  var object = new THREE.Mesh(geometry, mat);
  scene.add(object);

  var addEvents = function () {
    var evtIn = "mouseenter";
    var evtOut = "mouseleave";
    if (mobileAndTabletcheck()) {
      evtIn = "touchstart";
      evtOut = "touchend";
    }
    parent.addEventListener(
      evtIn,
      function (e) {
        TweenMax.to(mat.uniforms.dispFactor, speedIn, {
          value: 1,
          ease: easing,
        });
      },
      { passive: true }
    );

    parent.addEventListener(
      evtOut,
      function (e) {
        TweenMax.to(mat.uniforms.dispFactor, speedOut, {
          value: 0,
          ease: easing,
        });
      },
      { passive: true }
    );
  };

  if (userHover) {
    addEvents();
  }

  window.addEventListener("resize", function (e) {
    camera.left = parent.offsetWidth / -2;
    camera.right = parent.offsetWidth / 2;
    camera.top = parent.offsetHeight / 2;
    camera.bottom = parent.offsetHeight / -2;
    camera.updateProjectionMatrix();

    renderer.setSize(parent.offsetWidth, parent.offsetHeight);
  });

  window.next = function () {
    TweenMax.to(mat.uniforms.dispFactor, speedIn, {
      value: 1,
      ease: easing,
    });
  };

  window.previous = function () {
    TweenMax.to(mat.uniforms.dispFactor, speedOut, {
      value: 0,
      ease: easing,
    });
  };

  var animate = function () {
    requestAnimationFrame(animate);

    renderer.render(scene, camera);
  };
  animate();
};

const routes = [
  { name: "home", letter: "I" },
  { name: "shop", letter: "II" },
  { name: "about", letter: "III" },
  { name: "product" },
  { name: "terms and conditions", letter: "V" },
  { name: "privacy policy", letter: "VIII" },
  { name: "shipping and returns", letter: "VI" },
  { name: "contact", letter: "IV" },
];
export default {
  name: "OffcanvasMenu",
  data: function () {
    return {
      menuOpen: false,
      menuCanOpen: false,
      currentLetter: "H",
      varIsRing: false,
      symbol: "I",
      activeRoute: "",
      closeAnim: false,
      windowSize: 10000, //larger than the first change
      isSafari: false,
    };
  },
  methods: {
    animateMenuItem(letter, isRing, symbol) {
      var self = this;
      if (!self.closeAnim) {
        if (!self.varIsRing && !isRing) {
          if ($(".c-menu__ringname").css("opacity")) {
            TweenMax.to(".c-menu__ringname", 0.1, { opacity: 0 });
          }
          TweenMax.to(".c-menu__page--current", 0.2, {
            opacity: 0,
            y: -30,
            ease: Power1.easeOut,
          });
          setTimeout(function () {
            self.symbol = symbol;
            TweenMax.fromTo(
              ".c-menu__page--current",
              0.2,
              { opacity: 0, y: 30 },
              { opacity: 1, y: "-50%", ease: Power1.easeOut }
            );
          }, 250);
        } else if (self.varIsRing && isRing) {
          if ($(".c-menu__pagenumber").css("opacity")) {
            TweenMax.to(".c-menu__pagenumber", 0.1, { opacity: 0 });
          }
          TweenMax.to(".c-menu__ringname", 0.2, {
            opacity: 0,
            y: -30,
            ease: Power1.easeOut,
          });
          setTimeout(function () {
            self.symbol = symbol;
            TweenMax.fromTo(
              ".c-menu__ringname",
              0.2,
              { opacity: 0, y: 30 },
              { opacity: 1, y: 0, ease: Power1.easeOut }
            );
          }, 250);
        } else if (!self.varIsRing && isRing) {
          TweenMax.to(".c-menu__pagenumber", 0.2, {
            opacity: 0,
            y: -30,
            ease: Power1.easeOut,
          });
          setTimeout(function () {
            self.symbol = symbol;
            TweenMax.fromTo(
              ".c-menu__ringname",
              0.2,
              { opacity: 0, y: 30 },
              { opacity: 1, y: 0, ease: Power1.easeOut }
            );
          }, 250);
        } else if (self.varIsRing && !isRing) {
          TweenMax.to(".c-menu__ringname", 0.2, {
            opacity: 0,
            y: -30,
            ease: Power1.easeOut,
          });
          setTimeout(function () {
            self.symbol = symbol;
            TweenMax.fromTo(
              ".c-menu__pagenumber",
              0.2,
              { opacity: 0, y: 30 },
              { opacity: 1, y: 0, ease: Power1.easeOut }
            );
          }, 250);
        }
        self.varIsRing = isRing;

        TweenMax.to("#letter", 0.35, { opacity: 0, ease: Power1.easeOut });
        TweenMax.to("#letter", 0.4, { rotationY: "30", ease: Power1.easeOut });
        setTimeout(function () {
          self.currentLetter = letter;
          TweenMax.to("#letter", 0.35, { opacity: 1, ease: Power1.easeOut });
          TweenMax.fromTo(
            "#letter",
            0.4,
            { rotationY: "-30" },
            { rotationY: "0", ease: Power1.easeOut }
          );
        }, 300);
      }
    },
    toggleMenu() {
      var self = this;
      if (!this.menuOpen) {
        this.menuOpen = !this.menuOpen;
        this.$emit("toggleMenu", this.menuOpen);
        self.currentLetter = self.$route.name.slice(0, 1).toUpperCase();
        self.activeRoute = self.$route.name;
        routes.forEach(function (route) {
          if (route.name == self.$route.name) {
            self.symbol = route.letter;
          }
          if (self.$route.name != "product") {
            TweenMax.to(".c-menu__ringname", 0, {
              opacity: 0,
              y: -30,
              ease: Power1.easeOut,
            });
            self.varIsRing = false;
          } else {
            self.varIsRing = true;
            var name = self.$route.params.id.slice(
              5,
              self.$route.params.id.length
            );
            self.symbol = name;
            self.currentLetter = name.slice(0, 1).toUpperCase();
            TweenMax.to(".c-menu__pagenumber", 0, {
              opacity: 0,
              y: -30,
              ease: Power1.easeOut,
            });
            TweenMax.to(".c-menu__ringname", 0, {
              opacity: 1,
              y: 0,
              ease: Power1.easeOut,
            });
          }
        });
        this.animateMenuOpen();
      } else {
        this.animateMenuClose();
      }
    },
    animateMenuOpen() {
      var self = this;
      var menuItems = $(".c-menu__menu-itemInner");
      var images = $(".js-hover-effect");
      var letter = $("#letter");
      var pagination = $(".c-menu__pagination");
      var panels = $(".js-panel");
      var circle = $("#perspective-circle");
      var counters = $(".c-menu__counter");
      TweenMax.to(counters, 0, { opacity: 0 });
      TweenMax.to(circle, 0, { opacity: 0 });
      TweenMax.to(panels, 0, { opacity: 0 });
      TweenMax.to(menuItems, 0, { opacity: 0 });
      TweenMax.to(images, 0, { opacity: 0 });
      TweenMax.to(letter, 0, { opacity: 0 });
      TweenMax.to(pagination, 0, { opacity: 0 });
      $(panels[0]).css("background-color", "#101010");
      $(panels[1]).css("background-color", "#fff");
      $(panels[2]).css("background-color", "#101010");
      TweenMax.to(panels, 0, { scaleX: 1 });

      TweenMax.to(".app", 0.3, { x: 200, opacity: 0.1, ease: Power2.easeOut });
      TweenMax.to("#menu-mask", 0.5, { scaleX: 1, ease: Power2.easeOut });
      self.menuCanOpen = true;

      setTimeout(function () {
        $("#menu-mask").css("transform-origin", "right");
        TweenMax.to(panels, 0, { opacity: 1 });
        TweenMax.to("#menu-mask", 0.7, { scaleX: 0, ease: Power2.easeOut });
        TweenMax.staggerFromTo(
          images,
          1,
          { x: -40, opacity: 0 },
          { x: 0, opacity: 1, ease: Power4.easeOut },
          0.15
        );

        TweenMax.staggerFromTo(
          menuItems,
          0.7,
          { x: -100, opacity: 0 },
          {
            x: 0,
            opacity: 1,
            ease: Power2.easeOut,
            onComplete: function () {
              setTimeout(function () {
                menuItems.addClass("c-menu__menu-itemInner--canAnimate");

                setTimeout(function () {
                  menuItems.addClass("c-menu__menu-itemInner--anim-mobile");
                }, 10);
              }, 400);
            },
          },
          0.05
        );
        TweenMax.fromTo(
          circle,
          0.6,
          { scale: 0, opacity: 0 },
          { scale: 1, opacity: 0.1, ease: Power4.easeOut }
        );

        //DECORATIVE
        setTimeout(function () {
          //LETTER
          TweenMax.to("#letter", 3, { opacity: 1, ease: Power3.easeOut });
          TweenMax.fromTo(
            "#letter",
            3,
            { rotationY: "-30" },
            { rotationY: "0", ease: Power3.easeOut }
          );

          TweenMax.to(counters, 1.6, { opacity: 1, ease: Power3.easeOut });
          TweenMax.fromTo(
            pagination,
            1.6,
            { opacity: 0, y: 50 },
            { opacity: 1, y: 0, ease: Power3.easeOut }
          );
        }, 500);

        // var $divs = $('.c-menu__link-listItem');
        // var menuItems = $(".c-menu__menu-itemInner");
        // // var counters = $(".c-menu__counter");
        // var self = this;

        // setTimeout(function(){

        // }, 400)
      }, 550);
    },
    animateMenuClose() {
      var self = this;
      self.closeAnim = true;

      var menuItems = $(".c-menu__menu-itemInner");
      var images = $(".js-hover-effect");
      var letter = $("#letter");
      var pagination = $(".c-menu__pagination");
      var panels = $(".js-panel");
      var circle = $("#perspective-circle");
      var counters = $(".c-menu__counter");
      self.menuOpen = !this.menuOpen;
      this.$emit("toggleMenu", this.menuOpen);

      TweenMax.to(panels, 0, {
        backgroundColor: "#101010",
        ease: Power1.easeOut,
      });
      TweenMax.to(".app", 0, { x: 0 });
      menuItems.removeClass("c-menu__menu-itemInner--canAnimate");
      panels.css("transform-origin", "right");

      TweenMax.staggerTo(
        counters,
        0.3,
        { opacity: 0, ease: Power1.easeOut },
        0.05
      );
      TweenMax.to(letter, 0.3, { opacity: 0, ease: Power1.easeOut });
      TweenMax.to(letter, 0.4, { rotationY: "30", ease: Power1.easeOut });
      TweenMax.to(pagination, 0.4, {
        opacity: 0,
        y: -100,
        ease: Power3.easeOut,
      });
      TweenMax.staggerTo(
        images,
        0.5,
        { x: 45, opacity: 0, ease: Power4.easeOut },
        0.1
      );

      TweenMax.staggerTo(menuItems, 0.7, {
        x: -100,
        opacity: 0,
        ease: Power2.easeOut,
      });
      TweenMax.to(
        circle,
        0.6,
        { scale: 1, opacity: 0 },
        { scale: 0, opacity: 0.1, ease: Power4.easeOut }
      );
      setTimeout(function () {}, 300);
      setTimeout(function () {
        if (self.$route.name != "home" && self.$route.name != "about") {
          TweenMax.to(panels, 0.8, { scaleX: 0, ease: Power4.easeIn }, 0.15);
          self.closeAnim = false;
          setTimeout(function () {
            self.menuCanOpen = false;
            TweenMax.to(".app", 0.3, { opacity: 1, ease: Power2.easeIn });
          }, 845);
        } else {
          $(".c-menu__offcanvas").css("background", "#000000");
          $(".app-container").css("background", "#000000");
          self.closeAnim = false;
          self.menuCanOpen = false;
          TweenMax.to(".app", 0.3, { opacity: 1, ease: Power2.easeIn });
          TweenMax.to(panels, 0.7, { opacity: 0, ease: Power4.easeIn });
          setTimeout(function () {
            $(".c-menu__offcanvas").css("background", "#ffffff");
            $(".app-container").css("background", "#ffffff");
          }, 900);
        }
      }, 600);
    },
    sortOutImages: function () {
      var self = this;
      imagesLoaded(document.querySelectorAll(".js-menu-img"), () => {
        Array.from(document.querySelectorAll(".js-hover-effect")).forEach(
          (el, i) => {
            const imgs = Array.from(el.querySelectorAll("img"));
            var img1Src = imgs[0].getAttribute("src");
            var img2Src = imgs[1].getAttribute("src");
            var img1SrcImage;
            var img2SrcImage;

            Modernizr.on("webp", function (result) {
              var displacementMap = el.dataset.displacement;
              if (result) {
                img1SrcImage = imgUrls[i][0].replace("png", "webp");
                img2SrcImage = imgUrls[i][1].replace("png", "webp");
                displacementMap = displacementMap.replace("png", "webp");
              } else {
                img1SrcImage = imgUrls[i][0];
                img2SrcImage = imgUrls[i][1];
              }

              img1Src = img1SrcImage;
              img2Src = img2SrcImage;

              hoverEffect({
                parent: el,
                intensity: el.dataset.intensity || undefined,
                speedIn: el.dataset.speedin || undefined,
                speedOut: el.dataset.speedout || undefined,
                easing: el.dataset.easing || undefined,
                // hover: el.dataset.hover || undefined,
                image1: img1Src,
                image2: img2Src,
                displacementImage: displacementMap,
              });
            });
          }
        );
      });

      self.isChrome = /Google Inc/.test(navigator.vendor);
      if (self.isChrome) {
        var container = document.getElementById("offcanvas-perspective"),
          inner = document.getElementById("perspective-circle");
        var self = this;

        // Mouse
        var mouse = {
          _x: 0,
          _y: 0,
          x: 0,
          y: 0,
          updatePosition: function (event) {
            var e = event || window.event;
            this.x = e.clientX - this._x;
            this.y = (e.clientY - this._y) * -1;
          },
          setOrigin: function (e) {
            this._x = e.offsetLeft + Math.floor(e.offsetWidth / 2);
            this._y = e.offsetTop + Math.floor(e.offsetHeight / 2);
          },
          show: function () {
            return "(" + this.x + ", " + this.y + ")";
          },
        };

        // Track the mouse position relative to the center of the container.
        mouse.setOrigin(container);

        //----------------------------------------------------

        var counter = 0;
        var refreshRate = 10;
        var isTimeToUpdate = function () {
          return counter++ % refreshRate === 0;
        };

        //----------------------------------------------------

        var onMouseEnterHandler = function (event) {
          if (self.menuOpen) {
            update(event);
          }
        };

        var onMouseMoveHandler = function (event) {
          if (self.menuOpen) {
            if (isTimeToUpdate()) {
              update(event);
            }
          }
        };

        //----------------------------------------------------

        var update = function (event) {
          mouse.updatePosition(event);
          updateTransformStyle(
            (mouse.y / inner.offsetHeight / 2).toFixed(2),
            (mouse.x / inner.offsetWidth / 2).toFixed(2)
          );
        };

        var updateTransformStyle = function (x, y) {
          var style =
            "translateY(-50%) translateX(-50%) rotateX(" +
            x +
            "deg) rotateY(" +
            y +
            "deg)";
          inner.style.transform = style;
          inner.style.webkitTransform = style;
          inner.style.mozTranform = style;
          inner.style.msTransform = style;
          inner.style.oTransform = style;
        };

        //--------------------------------------------------------

        container.onmousemove = onMouseMoveHandler;
        container.onmouseenter = onMouseEnterHandler;
      }
    },
  },
  mounted() {
    var self = this;
    self.sortOutImages();

    var resizeTimer;
    $(window).on("resize", function (e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var w = window.innerWidth;
        if (w > self.windowSize) {
          self.sortOutImages();
        }
        self.windowSize = w;
      }, 250);
    });
  },
  props: {
    // navItems: Array,
    // blinker: Boolean,
  },
};
</script>



// WEBPACK FOOTER //
// OffcanvasMenu.vue?0dbcd33c